import { FiEmptyListModule } from './../../shared/fi-empty-list/fi-empty-list.module';
import { FiOptionsModule } from './../../shared/fi-options/fi-options.module';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Statistic2DashboardComponent } from '@fi-app/statistic2/statistic2-dashboard/statistic2-dashboard.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { Statistic2WidgetModule } from '@fi-app/statistic2/statistic2-widget/statistic2-widget.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        Statistic2WidgetModule,
        DragDropModule,
        MatIconModule,
        FiOptionsModule,
        FiEmptyListModule,
    ],
    declarations: [Statistic2DashboardComponent],
    exports: [Statistic2DashboardComponent],
})
export class Statistic2DashboardModule {}
